import {useQuery} from '@tanstack/react-query'

import {getDispatchReport} from './api'
import {dispatchReportKeys} from './query-keys'

export function useDispatchReport(reportDate: string) {
    return useQuery({
        queryKey: dispatchReportKeys.report(reportDate),
        queryFn: () => getDispatchReport(reportDate),
    })
}
